import axios from "axios";
import { ZodError } from "zod";

export const CONTRACT_VIOLATION_USER_MESSAGE =
  "Server returned an unexpected response. Please try again or contact support.";

export const getApiResponseErrorMsg = (e: unknown, context?: string): string => {
  let message = "Something went wrong, please try again later.";

  if (e instanceof ZodError) {
    console.error(`[Contract violation${context ? ` in ${context}` : ""}]`, e.issues);
    return CONTRACT_VIOLATION_USER_MESSAGE;
  }

  if (axios.isAxiosError(e) && e.response) {
    message = `${e.response?.data?.message || e.response?.statusText || message}`;
  } else if (e instanceof Error) {
    message = e.message;
  }

  return message;
};
